export const SET_SEARCH = 'SET_SEARCH';
export const CLEAR_SEARCH_TERM = 'CLEAR_SEARCH_TERM';
export const CLEAR_ALL_SEARCH = 'CLEAR_ALL_SEARCH';
export const SEARCH_UPDATE_OPERATOR = 'SEARCH_UPDATE_OPERATOR';
export const GET_SEARCH = 'GET_SEARCH';
export const SEARCH_HAS_ERRORED = "SEARCH_HAS_ERRORED";
export const SEARCH_IS_LOADING = "SEARCH_IS_LOADING";
export const SEARCH_FETCH_DATA_SUCCESS = "SEARCH_FETCH_DATA_SUCCESS";
export const SEARCH_SET_FILTER = "SEARCH_SET_FILTER";
export const SEARCH_CLEAR_FILTERS = "SEARCH_CLEAR_FILTERS";